import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Copy, Download, MessageCircle, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { usePrefs } from "@/contexts/PrefsContext";

export const PartnerInviteCard = () => {
  const { t } = usePrefs();
  const qr = useRef<HTMLDivElement>(null);
  const link = `${window.location.origin}/partner/register`;
  const msg = `${t("pinv.msg")}\n${link}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success(t("share.copied"));
    } catch {
      toast.error(link);
    }
  };
  const downloadQr = () => {
    const c = qr.current?.querySelector("canvas");
    if (!c) return;
    const a = document.createElement("a");
    a.href = c.toDataURL("image/png");
    a.download = "wayn-nrouh-partner-invite-qr.png";
    a.click();
  };
  const btn = "h-10 px-4 rounded-full text-sm font-bold inline-flex items-center gap-1.5 transition-[background-color,color]";
  return (
    <section data-testid="partner-invite-card" className="mb-6 rounded-3xl border bg-card p-5 flex flex-col sm:flex-row gap-5 sm:items-center">
      <div className="flex-1 min-w-0 space-y-3">
        <div className="flex items-center gap-2">
          <span className="h-9 w-9 rounded-2xl bg-primary/10 text-primary grid place-items-center"><UserPlus className="h-5 w-5" /></span>
          <div><p className="font-bold">{t("pinv.title")}</p><p className="text-xs text-muted-foreground">{t("pinv.sub")}</p></div>
        </div>
        <p dir="ltr" data-testid="partner-invite-link" className="rounded-2xl bg-muted px-3 py-2 text-xs font-mono break-all text-start">{link}</p>
        <div className="flex flex-wrap gap-2">
          <button onClick={copy} data-testid="partner-invite-copy" className={`${btn} bg-foreground text-background hover:bg-foreground/90`}><Copy className="h-4 w-4" />{t("share.copyLink")}</button>
          <a href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" data-testid="partner-invite-whatsapp" className={`${btn} bg-[#25D366] text-white hover:bg-[#1ebe5b]`}><MessageCircle className="h-4 w-4" />{t("pinv.whatsapp")}</a>
          <button onClick={downloadQr} data-testid="partner-invite-qr-download" className={`${btn} border hover:bg-accent`}><Download className="h-4 w-4" />{t("pinv.qr")}</button>
        </div>
      </div>
      <div ref={qr} data-testid="partner-invite-qr" className="self-center rounded-2xl bg-white p-3 border">
        <QRCodeCanvas value={link} size={512} level="H" marginSize={2} style={{ width: 128, height: 128 }}
          imageSettings={{ src: "/logo.png", height: 100, width: 100, excavate: true }} />
      </div>
    </section>
  );
};
